import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReportRow, EnumExportStatus, formStatusToApprovalStatus } from 'src/app/models/report.model';
import { EReplyStatus } from 'src/app/models/recipients.model';
import { QueDatePipe } from 'src/app/pipes/date.pipe';
import { Router } from '@angular/router';
import { ReportStore } from '../../store/report-store';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ApprovalExpenseRowsComponent } from 'src/app/features/approvals/components/approval-expense-rows/approval-expense-rows.component';
import { ExtraDetailsComponent } from 'src/app/features/questionnaires/features/table-grid/features/questionnaires-list-page/components/extra-details/extra-details.component';
import { ReportsMenuItemComponent } from '../reports-menu-item/reports-menu-item.component';

@Component({
  selector: 'que-reports-list-item',
  imports: [CommonModule, QueDatePipe, TranslateDirective, TranslatePipe, ApprovalExpenseRowsComponent, ExtraDetailsComponent, ReportsMenuItemComponent],
  templateUrl: './reports-list-item.component.html',
  styleUrls: ['./reports-list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReportsListItemComponent {
  @Input() report?: ReportRow;
  #reportStore = inject(ReportStore);
  #router = inject(Router);

  eEnumExportStatus = EnumExportStatus;
  eEnumReplyStatus = EReplyStatus;

  expandedIds$ = toSignal(this.#reportStore.expandedIds$);
  expenseRowsByApprovalId$ = toSignal(this.#reportStore.expenseRowsByApprovalId$);
  loadingExpenseRowsIds$ = toSignal(this.#reportStore.loadingExpenseRowsIds$);
  expenseRowsErrorByApprovalId$ = toSignal(this.#reportStore.expenseRowsErrorByApprovalId$);

  get isExpanded(): boolean {
    return !!(this.report && this.expandedIds$()?.[this.report.id]);
  }
  get expenseRows() {
    return this.report ? this.expenseRowsByApprovalId$()?.[this.report.id] : undefined;
  }
  get isLoadingExpenseRows(): boolean {
    return !!(this.report && this.loadingExpenseRowsIds$()?.[this.report.id]);
  }
  get expenseRowsError(): string | undefined {
    return this.report ? this.expenseRowsErrorByApprovalId$()?.[this.report.id] || undefined : undefined;
  }

  toggleExpand() {
    if (this.report) this.#reportStore.toggleExpand(this.report);
  }

  reportClick() {
    if (this.report?.recipientGuid) {
      this.#router.navigate([
        'viewAnswers',
        this.report.recipientGuid,
        formStatusToApprovalStatus(this.report.formStatus)
      ]);
    }
  }
}
